import React from "react";
import { useNavigate } from "react-router-dom";

const CorporateTraining = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-br from-[#0f2244] to-[#1e3a6e] text-white rounded-3xl p-10 flex flex-col md:flex-row items-center gap-8 shadow-xl border border-white/10 relative overflow-hidden group">
      {/* Glow accent */}
      <div className="absolute top-0 right-0 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl pointer-events-none" />
      
      <div className="flex-1 space-y-4 relative z-10 text-left">
        <h3 className="text-3xl font-extrabold tracking-tight">Corporate Training</h3>
        <p className="text-blue-100 text-base leading-relaxed max-w-md">
          Upskill your organization or team. Contact us to design custom pathways, flexible schedules, and private cohorts.
        </p>
        <button 
          onClick={() => navigate("/contact")}
          className="btn-outline-custom !border-white !text-white hover:!bg-white hover:!text-[#0f2244] !shadow-none !bg-transparent mt-2 px-8 py-3.5"
        >
          Contact Us
        </button>
      </div>
      <div className="flex-shrink-0 relative z-10 w-full md:w-auto">
        <img 
          src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&h=400&fit=crop" 
          alt="Corporate Training" 
          className="w-full md:w-[260px] h-[180px] object-cover rounded-2xl shadow-lg border border-white/10 group-hover:scale-102 transition-transform duration-300"
        />
      </div>
    </div>
  );
};

export default CorporateTraining;
